import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Page_settings } from "@/config/page_settings";
import { useNavigate } from "react-router-dom";
import { API_URL, RESULT_CODE } from "@/config/const";

const BillConfirmPage = () => {
  /* **********************************
    * GLOBAL STATE
    * 전역 상태 및 전역 변수
    ********************************** */
  const navigate = useNavigate();
  const context: any = useContext(Page_settings);
  //const [data, setData] = useState(null);

  const [chewingplusKey, setChewingplusKey] = useState("");
  const [approvalAmount, setApprovalAmount] = useState("0");

  useEffect(() => {
    //결제요청 메시지에서 츄잉플러스 요청키 값 가져오기(ex:payKey)
    const params = new URLSearchParams(window.location.search);
    const chewingplusKey = params.get('chewingplusKey'); // "12345678"    
    
    setChewingplusKey(chewingplusKey);
        
  }, []); 

  //츄잉플러스 결체조회 호출
  const goChewingplusCancelPage = (data) => {
    context.post(
      `/chewingplus/payTestSearch`,  //츄잉플러스 URL  /platform/payTestRequest
      {
        chewingplusKey: chewingplusKey,
      },
      (response) => {
        console.log(response);
        //setData(response); // 상태에 JSON 데이터 할당
        goPaymentCancelPage(response);
      }
    );
  };

  //츄잉페이 결제조회 서비스 호출
  const goPaymentCancelPage = (data) => {
    context.post(
      '/api/searchPayment',
      data,
      (response) => {
        if(response.RESULT_CODE === "0000"){  //결제조회성공
          //alert(response.RESULT_CODE);
          console.log(response);
          //츄잉플러스 페이지로 이동
        }else{ //요청실패
          alert(response.RESULT_CODE);
          alert(response.RESULT_MSG);
        }
      }
    );
  }; 

  return (
    <div>
      <h3>카리페이 결제조회(수동테스트)</h3>
      <div>
         <label>거래고유번호(TRANS_SEQNO): </label>
         <input
           type="text"
           name="chewingplusKey"
           value={chewingplusKey}
           onChange={(e) => setChewingplusKey(e.target.value)}
         />
       </div>
      <button onClick={goChewingplusCancelPage}>결제조회</button>
    </div>
  );
}

export default BillConfirmPage;